module.exports = __webpack_public_path__ + "static/img/suisui3.666e91c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suisui3.svg
// module id = YA5e
// module chunks = 0